import { useState, useCallback } from "react";
import { APPLIED_JOBS_FINDER } from "../../Utils/apis";

const useFetchAppliedJobs = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [jobs, setJobs] = useState([]);

  const fn = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const res = await fetch(APPLIED_JOBS_FINDER, {
        method: "GET",
        credentials: "include",
      });

      if (res.status === 401 || res.status === 403) {
        
        
        
        setJobs([]);
        return [];
      }

      const response = await res.json();

      if (!res.ok) {
        throw new Error(
          response?.message ||
            response?.error ||
            "Unable to fetch applied jobs.",
        );
      }

      const data = response?.data;

      const jobArray = Array.isArray(response)
        ? response
        : Array.isArray(data)
          ? data
          : [];

      setJobs(jobArray);
      return jobArray;
    } catch (err) {
      setError(err.message || "Unable to fetch applied jobs.");
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return [loading, error, jobs, fn];
};

export default useFetchAppliedJobs;
